import adConversionTracker from "./adConversions";

// Export Pendo session utilities for use in other apps
export {
  storePendoSession,
  getPendoSession,
  clearPendoSession,
  hasPendoSession,
  initializePendoFromSession
} from "./pendoSessionStorage";

// Middleware that sends ad conversions for dispatched actions.
function analytics() {
  return function analyticsMiddleware(next) {
    return function handleAnalyticsAction(action) {
      adConversionTracker(action);

      return next(action);
    };
  };
}

export default analytics;
